/**
 * Book's "what" (1.8.3, D-1.8.3-3): Housekeeping · Companion & Wellness · Reading & Services · Tech Support ·
 * Volunteer help — one row, one order, at the top of every Book sheet. The one that is open is pressed; pressing
 * another opens that program's sheet with the tenant already chosen kept. Only what the signed-in role may book is
 * offered (shared/book-programs.ts): the scheduler sees Housekeeping alone (26 Oct 2026), so no question is asked.
 *
 * The question is printed above the row ("What are you booking?") and names the group. On a phone the five wrap to
 * two columns (b183-b.css) — nothing scrolls sideways; the pressed one carries a tick, never colour alone.
 */
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { bookProgramsFor, type BookProgram } from '@shared/book-programs';
import { useMe } from '@/auth/useMe';

export function ProgramPicker({ value, onChange }: { value: BookProgram; onChange: (program: BookProgram) => void }) {
  const { t } = useTranslation();
  const me = useMe();
  const id = useId();
  const offered = bookProgramsFor(me.data?.role ?? null);
  if (offered.length < 2) return null;
  return (
    <div className="book183-what">
      <span className="eyebrow" id={id}>
        {t('book183.what')}
      </span>
      <div className="seg book183-programs" role="group" aria-labelledby={id} data-testid="book-program" data-count={offered.length}>
        {offered.map((p) => (
          <button key={p} type="button" aria-pressed={p === value} onClick={() => (p === value ? undefined : onChange(p))} data-testid={`book-program-${p}`}>
            {t(`book183.program.${p}`)}
          </button>
        ))}
      </div>
    </div>
  );
}
